import { Row } from '@tanstack/react-table';
import _isNil from 'lodash/isNil';

export function isSelectedRow(row: Row<any>, selectedEntity: any): boolean {
    if (_isNil(selectedEntity)) {
        return false;
    }
    const original: any = row.original;
    for (const prop in original) {
        if (
            !Object.prototype.hasOwnProperty.call(selectedEntity, prop) ||
            selectedEntity[prop] !== original[prop]
        ) {
            return false;
        }
    }
    return true;
}

export function handleCellInputChange(event, entity: any): any {
    let value = event.target.value;

    if (event.target.type === 'number') {
        value = parseFloat(value);
    } else if (event.target.type === 'checkbox') {
        value = event.target.checked;
    }

    const updatedEntity = {
        ...entity,
        [event.target.name]: value,
    };

    return updatedEntity;
}
